<!-- videos -->
<div class="section section-videos container-fluid height-auto bg-half-brand">

  <a class="section-anchor" name="section-videos"></a>

  <h2 class="alternate-heading text-center">
    <span class="text-primary">{{'Images2' | translate}}</span> {{'say' | translate}}<br>
    {{'More than a thousand words' | translate}}
  </h2>

  <p class="alternate-heading-subline text-center">
    {{'View our most recent videos here' | translate}}
  </p>

  <div class="slider-videos-wrapper">

    <div class="slider-videos">

      <ngb-carousel [showNavigationArrows]="true" [showNavigationIndicators]="false" *ngIf="videos">
        <ng-template *ngFor="let slide of videos" ngbSlide>

          <div class="row">
            <div class="col-6 col-sm-6" *ngFor="let slideItem of slide">

              <div class="video">

                <a (click)="videoService.openVideo(slideItem.videoUri)" class="video-link shadow cursor-pointer">
                  <div class="grid-item-image-wrapper">
                    <div class="ytImgContainer">
                      <div class="ytImgWrapper">
                        <div class="ytImgThumbBox">
                          <img class="grid-item-image image-video img-responsive img-fluid ytImgThumbImg" [src]="videoService.getYoutubeThumbnail(slideItem['videoUri'])" />
                        </div>
                      </div>
                    </div>

                  </div>

                  <div class="play-icon"></div>
                </a>

              </div>

            </div>
          </div>
        </ng-template>
      </ngb-carousel>

    </div>

  </div>

  <div class="row row-button-more">

    <div class="col-12 text-center">

      <a routerLink="/videos" class="btn btn-light btn-white btn-special">
        {{'More videos' | translate}}
      </a>

    </div>

  </div>

</div>
